import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTheme } from '../Flowbite/ThemeContext';
export var FooterIcon = function FooterIcon(_ref) {
  var href = _ref.href,
    className = _ref.className,
    ariaLabel = _ref.ariaLabel,
    Icon = _ref.icon;
  var theme = useTheme().theme.footer.icon;
  return _jsx("div", {
    children: href ? _jsx("a", {
      "aria-label": ariaLabel,
      "data-testid": "flowbite-footer-icon",
      href: href,
      className: classNames(theme.base, className),
      children: _jsx(Icon, {
        className: theme.size
      })
    }) : _jsx(Icon, {
      "data-testid": "flowbite-footer-icon",
      className: theme.size
    })
  });
};